import type { RecordAudit } from '../types';

export function omitManagedRecordFields<T extends object>(row: T): Omit<T, keyof RecordAudit> {
  const copy = { ...row } as Record<string, unknown>;
  delete copy.created_at;
  delete copy.updated_at;
  delete copy.created_by;
  delete copy.updated_by;
  return copy as Omit<T, keyof RecordAudit>;
}
